/**
 * Las direcciones de antes de separar el panel (`/admin/*`) de las
 * aplicaciones publicadas (`/<enlace>`), traducidas a las de ahora. Los
 * enlaces guardados y compartidos siguen funcionando.
 */
export function legacyPath(pathname: string): string | null {
  if (pathname === "/directorio") return "/";
  if (pathname === "/entrar") return "/admin/entrar";
  if (pathname === "/demo") return "/admin/demo";
  if (/^\/(a|ajustes)(\/|$)/.test(pathname)) return `/admin${pathname}`;
  const app = /^\/p\/(.+)$/.exec(pathname);
  if (app) return `/${app[1]}`;
  if (pathname === "/p" || pathname === "/p/") return "/";
  return null;
}
